import React from "react";
import {
  ChevronRightIcon,
} from "@heroicons/react/24/outline";
import { NavbarUser } from "../navigation/NavbarUser";
import { NestedListBackoffice } from "../nestedList/nestedList";
import {
  CloudUpload,
  MonetizationOnRounded,
  PaymentsRounded,
  PaymentRounded,
  CreditScoreRounded,
  InfoRounded,
  InfoTwoTone,
  SettingsApplicationsTwoTone,
  SettingsApplicationsSharp,
  ListAltRounded,
  PaymentTwoTone,
  CreditCard
} from '@mui/icons-material';
import { Cash, CheckCircle, CheckCircleOutline } from "heroicons-react";




export function DashboardsBackOffice(props) {

  const navigationImports = [
    {
      name: "Cargue de cupos",
      href: "/backoffice-import-quotas",
      icon: < MonetizationOnRounded />,
      current: props.current1,
    },
    {
      name: "Cargue de pagos",
      href: "/backoffice-import-payments",
      icon: <PaymentsRounded />,
      current: props.current2,
    },
    {
      name: "Aumento de cupos",
      href: "/backoffice-import-incrementquotas",
      icon: <PaymentRounded />,
      current: props.current3,
    },
    {
      name: "Cargue de extensiones",
      href: "/backoffice-import-extendsCredit",
      icon: <CreditScoreRounded />,
      current: props.current5,
    },
    {
      name: "Cargue de lista restrictiva Galilea",
      href: "/backoffice-generar-lista-restrictiva-galilea",
      icon: <ListAltRounded />,
      current: props.current6,
    },
    {
      name: "Cargue de desembolsos",
      href: "/backoffice-import-disbursements",
      icon: <PaymentsRounded />,
      current: props.current12,
    },
  ];

  const navigationReports = [
    {
      name: "Reporte Acierta",
      href: "/backoffice-reporteacierta",
      icon: <InfoRounded />,
      current: props.current8,
    },
    {
      name: "Reporte Reconocer +",
      href: "/backoffice-reportereconocer",
      icon: <InfoRounded />,
      current: props.current9,
    },
    {
      name: "Reporte Políticas Motor",
      href: "/backoffice-politicas-motor",
      icon: <InfoRounded />,
      current: props.current10,
    },
    {
      name: "Reporte Utm Leads",
      href: "/backoffice-utm-leads",
      icon: <InfoRounded />,
      current: props.current12,
    },
  ]

  const navigationConfigurations = [
    {
      name: "TMLV",
      href: "/backoffice-tmlv",
      icon: <SettingsApplicationsSharp />,
      current: props.current6,
    },
    {
      name: "Facturación electrónica Siigo",
      href: "/backoffice-fesiigo",
      icon: <SettingsApplicationsSharp />,
      current: props.current7,
    },
    {
      name: "Generar contrato crédito",
      href: "/backoffice-generar-contrato",
      icon: <SettingsApplicationsSharp />,
      current: props.current8,
    },
    {
      name: "Generar pagaré crédito",
      href: "/backoffice-generar-pagare",
      icon: <SettingsApplicationsSharp />,
      current: props.current13,
    },
    {
      name: "Interés corriente",
      href: "/backoffice-inrteres-corriente",
      icon: <SettingsApplicationsSharp />,
      current: props.current10,
    },
    {
      name: "Interés moratorio",
      href: "/backoffice-interes-moratorio",
      icon: <SettingsApplicationsSharp />,
      current: props.current11,
    }
  ];

  const navigationPayments = [
    {
      name: "Generar link Cobre",
      href: "/backoffice-generate-link-cobre",
      icon: <Cash />,
      current: props.current9,
    },
  ];

  const navigationVerifyAccount = [
    {
      name: "Crear cuenta verificada",
      href: "/backoffice-create-verify-account",
      icon: <CheckCircleOutline />,
      current: props.current10,
    },
  ];

  return (
    <>
      <div className="flex pt-12 md:py-20">
        {/* Static sidebar for desktop */}
        <div className="hidden mt-4 md:block text-tdark md:min-h-0 md:w-80 " style={{ borderRight: '1.5px solid #201933' }}>
          <div className="mx-2 h-full grid content-between">
            <nav className="mt-10" aria-label="Sidebar">
              <div className="space-y-3 h-full">
                <NestedListBackoffice labelList={'Importar'} iconList={<CloudUpload />} listItems={navigationImports}></NestedListBackoffice>
                <NestedListBackoffice labelList={'Reportes'} iconList={<InfoTwoTone />} listItems={navigationReports}></NestedListBackoffice>
                <NestedListBackoffice labelList={'Configuraciones'} iconList={<SettingsApplicationsTwoTone />} listItems={navigationConfigurations}></NestedListBackoffice>
                <NestedListBackoffice labelList={'Pagos'} iconList={<CreditCard />} listItems={navigationPayments}></NestedListBackoffice>
                <NestedListBackoffice labelList={'Verificar cuenta'} iconList={<CheckCircle />} listItems={navigationVerifyAccount}></NestedListBackoffice>
              </div>
            </nav>

          </div>
        </div>
        <div className="flex flex-col min-w-0 flex-1 h-full md:h-128">
          <div className="flex-1 relative z-0 flex">
            <main className=" flex-1 relative z-0 focus:outline-none">
              {/* Start main area*/}
              <div className="py-12 px-4 sm:px-6 lg:px-8 h-full" style={{ backgroundColor: 'rgb(255 136 145 / 38%)' }}>
                <div>
                  <h1 className="font-bold text-4xl">{props.title}</h1>
                  {props.main}
                </div>
              </div>
              {/* End main area */}
            </main>
            <aside className="hidden pt-4 relative lg:flex lg:flex-col flex-shrink-0 w-60 xl:w-80" style={{ borderLeft: '1.5px solid #201933' }}>
              {/* Start secondary column (hidden on smaller screens) */}
              <div className="grid content-between h-full">
                <div>
                  <div>
                    <a
                      href="/perfil"
                      className="flex bg-tdark text-white py-4 px-4 lg:w-5/6 xl:w-2/3 rounded-r-full"
                    >

                      <div className="grid content-end pb-0.5">
                        <ChevronRightIcon className="w-6 h-auto" />
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              {/* End secondary column */}
            </aside>
          </div>
        </div>
      </div>
    </>
  );
}
